import ObjectHelper from '@/helpers/objectHelper'

const SamplingService = {
    isSampleStored(store) {
        return !ObjectHelper.isEmpty(store.getters['apiSample/sample'])
    },

    isSamplingCampaign(store) {
        return store.getters['apiCampaign/isSampling']
    },

    localStorage() {
        return {
            getSample: () => {
                const sampleRaw = window.localStorage.getItem('sample')
                
                if (!sampleRaw) {
                    return null
                }

                return JSON.parse(sampleRaw)
            },

            saveSample: (data) => {
                window.localStorage.setItem('sample', JSON.stringify(data))
            }
        }
    },

    shouldRedirectToSamplingOnce(store) {
        const out = this.isSamplingCampaign(store) && !store.getters['apiCampaign/isSamplingSeen']

        if (out) {
            store.dispatch('apiCampaign/setIsSamplingSeen', true, { root: true })
        }

        return out
    },

    storeSample(store, data) {
        if (!data.sampleId) {
            console.error(`[Sampling Service] No serviceId provided; data object: `, data)
        }

        store.dispatch('apiSample/setSample', data, { root: true })
        store.dispatch('apiSample/setSelectedSampleId', data.sampleId, { root: true })
    }
}

export default SamplingService